// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"3059906c","1441":"a6882834","2051":"3059906c","6023":"5e9a69b9","6059":"b8899527","7087":"39a4a8ba","7356":"d1b21a10"}[chunkId] + ".chunk.css";
};